import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    // useLenis owns route scrolling. Keeping this component passive avoids
    // a second native reset that would cancel Lenis' smooth transition.
  }, [pathname]);

  return null;
}